// src/vocabulary/B2/unit2/content.js

const content = {
  level: "B2",
  unit: 2,
  title: "Work & Daily Responsibilities",
  description:
    "Vocabulary related to work, responsibilities, and daily duties. Learn how to talk about tasks, schedules, and obligations.",

  explanation: [
    "This unit focuses on work life and daily responsibilities.",
    "You will learn words related to jobs, tasks, and duties.",
    "These words are useful when talking about your job or studies.",
    "People often use these words to explain what they do every day.",
    "For example: I work full-time. I have many responsibilities.",
    "You can also talk about deadlines and schedules.",
    "This vocabulary helps you speak more clearly about professional life.",
    "Try to describe your daily responsibilities using these words."
  ],

  items: [
    {
      word: "job",
      phonetic: "/dʒɒb/",
      meaning: "وظيفة",
      example: "She has a full-time job."
    },
    {
      word: "work",
      phonetic: "/wɜːrk/",
      meaning: "عمل",
      example: "I work from nine to five."
    },
    {
      word: "responsibility",
      phonetic: "/rɪˌspɒnsəˈbɪləti/",
      meaning: "مسؤولية",
      example: "Teaching is a big responsibility."
    },
    {
      word: "task",
      phonetic: "/tɑːsk/",
      meaning: "مهمة",
      example: "I finished my task on time."
    },
    {
      word: "deadline",
      phonetic: "/ˈdedlaɪn/",
      meaning: "موعد نهائي",
      example: "We must meet the deadline."
    },
    {
      word: "schedule",
      phonetic: "/ˈʃedjuːl/",
      meaning: "جدول",
      example: "My schedule is very busy this week."
    },
    {
      word: "full-time",
      phonetic: "/ˌfʊl ˈtaɪm/",
      meaning: "دوام كامل",
      example: "He works full-time."
    }
  ]
};

export default content;


